import React, { useState } from 'react';

function Modal({ onSubmit }) {
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation du pseudo : trimmed pour éviter les espaces de début/fin
        // Min 2 caractères pour éviter des noms trop courts
        if (!username.trim()) {
            setError('Veuillez entrer un pseudo');
            return;
        }

        if (username.trim().length < 2) {
            setError('Le pseudo doit contenir au moins 2 caractères');
            return;
        }

        // Le pseudo est validé et trimmed avant d'être passé au parent (App.js)
        onSubmit(username.trim());
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h1>Memory Game</h1>
                <p>Entrez votre pseudo pour commencer</p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Votre pseudo..."
                        value={username}
                        onChange={(e) => {
                            setUsername(e.target.value);
                            // Clear l'erreur dès que l'utilisateur tape (UX meilleure)
                            setError('');
                        }}
                        className="modal-input"
                        autoFocus
                    />

                    {error && <p className="modal-error">{error}</p>}

                    <button type="submit" className="modal-btn">
                        Commencer
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Modal;
